import { render } from "./new-client-pf.vue?vue&type=template&id=1c0bb778"
import script from "./new-client-pf.vue?vue&type=script&lang=js"
export * from "./new-client-pf.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__